import type { FieldGroup } from './types.js';

export const mbtiOptions = [
  { value: 'INTJ', label: 'INTJ — The Architect' },
  { value: 'INTP', label: 'INTP — The Logician' },
  { value: 'ENTJ', label: 'ENTJ — The Commander' },
  { value: 'ENTP', label: 'ENTP — The Debater' },
  { value: 'INFJ', label: 'INFJ — The Advocate' },
  { value: 'INFP', label: 'INFP — The Mediator' },
  { value: 'ENFJ', label: 'ENFJ — The Protagonist' },
  { value: 'ENFP', label: 'ENFP — The Campaigner' },
  { value: 'ISTJ', label: 'ISTJ — The Logistician' },
  { value: 'ISFJ', label: 'ISFJ — The Defender' },
  { value: 'ESTJ', label: 'ESTJ — The Executive' },
  { value: 'ESFJ', label: 'ESFJ — The Consul' },
  { value: 'ISTP', label: 'ISTP — The Virtuoso' },
  { value: 'ISFP', label: 'ISFP — The Adventurer' },
  { value: 'ESTP', label: 'ESTP — The Entrepreneur' },
  { value: 'ESFP', label: 'ESFP — The Entertainer' },
  { value: 'dont_know', label: "Don't know yet" },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
] as const;

export const psychologicalAssessment: FieldGroup = {
  key: 'psychological_assessment',
  label: 'Psychological Assessment',
  step: 5,
  description: 'Personality type and Big Five traits.',
  fields: [
    {
      order: 1,
      key: 'mbtiType',
      label: 'MBTI Type',
      type: 'single_select',
      step: 5,
      isOnboarding: true,
      optional: true,
      options: [...mbtiOptions],
    },
    {
      order: 2,
      key: 'oceanScores',
      label: 'Big Five (OCEAN)',
      type: 'object',
      step: 5,
      isOnboarding: true,
      optional: true,
      description:
        'Openness, Conscientiousness, Extraversion, Agreeableness, Neuroticism (1-100 each)',
    },
  ],
};
